import { IResult } from '../types/IResponse';
import { IIdItem } from '../types/resourceParts';
import { Request } from './Request';

export interface ISetDatasourceRemoteAgentReservationParams extends IIdItem {
  remoteAgentReservationId: string;
}

export interface ISetDatasourceRemoteAgentReservationResult extends IResult {
  updatedRemoteAgentName: string;
}

export class SetDatasourceRemoteAgentReservationRequest
  extends Request<ISetDatasourceRemoteAgentReservationParams, ISetDatasourceRemoteAgentReservationResult> {

  constructor(params: ISetDatasourceRemoteAgentReservationParams) {
    super('setDatasourceRemoteAgentReservation', params);
  }
}
